import styled from "styled-components";

export const Background = styled.div`
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 10px 0;
  background-color: #f0f0f0;
  box-sizing: border-box;
  -moz-box-sizing: border-box;

  .hidden {
    position: relative;
    z-index: 0;

    @media print {
      display: none;
    }
  }

  @page {
    size: A4 portrait;
    margin: 1cm 1cm 2cm;
  }

  @page :first {
    margin-top: 0;
  }

  @media print {
    width: 210mm;
    height: 297mm;
  }
`;

export const Page = styled.div`
  width: 210mm;
  min-height: 297mm;
  padding: 5mm;
  margin: 10mm auto;
  background: white;

  @media print {
    margin: 0;
    border: none;
    border-radius: 0;
    box-shadow: none;
    page-break-after: always;
  }
`;

export const Subpage = styled.div`
  /* Allow content to flow naturally for automatic page breaks */
  height: auto;
`;

export const Images = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-around;
  align-items: center;
  margin-bottom: 30px;
  img {
    &:nth-child(1) {
      height: 60px;
    }
    &:nth-child(2) {
      height: 40px;
    }
  }
`;

export const Breaker = styled.div`
  width: 100%;
  height: fit-content;
`;

export const Content = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 5px;
`;

export const Title = styled.h1`
  font-size: 18px;
  text-align: center;
  padding: 20px 0;
`;

export const Table = styled.table`
  font-size: 10px;
  width: 100%;
  text-align: center;
  margin: 20px 0;
  border-collapse: collapse;
  position: relative;

  thead {
    display: table-header-group;
  }
  tfoot {
    display: table-footer-group;
  }
  tr {
    page-break-inside: avoid;
  }

  .curso {
    min-width: 5rem;
    width: 5rem;
    max-width: 5rem;
  }
  .centro_custo {
    min-width: 3rem;
    width: 3rem;
    max-width: 3rem;
  }
  .disciplina {
    min-width: 5rem;
    width: 5rem;
    max-width: 5rem;
  }
  .carga {
    min-width: 1rem;
    width: 1rem;
    max-width: 1rem;
  }

  th,
  td {
    border: 0.1px solid #000;
    padding: 5px;
    text-transform: uppercase;
    white-space: normal; /* permite quebra de linha */
    word-break: break-word; /* força quebra dentro de palavras longas */
  }
`;

export const Assinaturas = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  width: 100%;
  position: relative;
  z-index: 5;

  div {
    font-size: 12px;
  }
`;
